export default function ElectricKettle() {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_845_5976)">
                <path
                    d="M33 16.5003C33.2569 16.5207 35.0041 16.4744 35.25 16.5003C39.75 16.5003 42 20.2275 42 23.2503C42 24.7503 41.25 27.7503 38.9008 29.5108C38.643 29.6769 37.0294 29.8401 36.75 30.0003"
                    stroke="#949494"
                    strokeWidth="2.25"
                />
                <path
                    d="M14.6562 16.5C13.3229 16.5 11.3229 16.5 8.65625 16.5C9.0717 17.4119 10.958 21.4958 11.9992 21.75"
                    stroke="#949494"
                    strokeWidth="2.25"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24 4.5C24.4142 4.5 24.7893 4.66791 25.0607 4.93939C25.3321 5.21082 25.5 5.5858 25.5 6C25.5 6.4142 25.3321 6.78918 25.0607 7.06061C24.7893 7.33209 24.4142 7.5 24 7.5C23.5858 7.5 23.2107 7.33209 22.9393 7.06061C22.6679 6.78918 22.5 6.4142 22.5 6C22.5 5.5858 22.6679 5.21082 22.9393 4.93939C23.2107 4.66791 23.5858 4.5 24 4.5Z"
                    stroke="#949494"
                    strokeWidth="1.8"
                />
                <path
                    d="M37.2759 38.898C37.2941 38.7124 37.3113 38.5262 37.3274 38.3392C37.441 37.0192 37.5 35.665 37.5 34.285C37.5 27.7273 36.1671 21.7527 33.9811 17.2597C31.5121 12.1848 27.9546 9 24 9C20.0292 9 16.4587 12.211 13.9885 17.3222C11.8205 21.8081 10.5 27.7577 10.5 34.285C10.5 35.6924 10.5614 37.0729 10.6794 38.4176C10.6965 38.6125 10.7148 38.8066 10.7343 39"
                    stroke="#949494"
                    strokeWidth="2.25"
                />
                <path d="M15 16.5H34.5" stroke="#949494" strokeWidth="2.25" />
                <path d="M22.5 34.5H25.5" stroke="#949494" strokeWidth="2.25" strokeLinecap="round" />
                <rect x="8.625" y="38.625" width="30.75" height="3.75" rx="1.875" stroke="#949494" strokeWidth="2.25" />
            </g>
            <defs>
                <clipPath id="clip0_845_5976">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
